"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthHelper = void 0;
var axios_1 = require("axios");
var base64url_1 = require("base64url");
var jwt_decode_1 = require("jwt-decode");
var OAuthHelper = /** @class */ (function () {
    function OAuthHelper() {
    }
    OAuthHelper.finishAuthorization = function (wsUrl, clientId, clientSecret, codeVerifier, authorizationCode, redirectUrl, callback) {
        var params = new URLSearchParams();
        params.append('code_verifier', codeVerifier);
        params.append('client_id', clientId);
        params.append('client_secret', clientSecret);
        params.append('code', authorizationCode);
        params.append('redirect_uri', redirectUrl);
        params.append('grant_type', 'authorization_code');
        OAuthHelper.callTokenEndpoint(wsUrl, params, callback);
    };
    OAuthHelper.refreshToken = function (wsUrl, clientId, clientSecret, refreshToken, callback) {
        var params = new URLSearchParams();
        params.append('client_id', clientId);
        params.append('client_secret', clientSecret);
        params.append('refresh_token', refreshToken);
        params.append('grant_type', 'refresh_token');
        OAuthHelper.callTokenEndpoint(wsUrl, params, callback);
    };
    OAuthHelper.getWebServiceUrl = function (refreshToken) {
        var parts = refreshToken.split('.');
        if (parts.length !== 2) {
            throw new Error('Invalid token supplied');
        }
        return base64url_1.default.decode(parts[1]);
    };
    OAuthHelper.getUserName = function (accessToken) {
        var parts = jwt_decode_1.default(accessToken);
        return parts.username;
    };
    OAuthHelper.callTokenEndpoint = function (wsUrl, params, callback) {
        axios_1.default.post(wsUrl + '/auth/connect/token', params, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(function (response) {
            callback(response.data);
        })
            .catch(function (error) {
            if (error.response) {
                if (error.response.status == 400) {
                    callback(error.response.data);
                    return;
                }
            }
            throw new Error('Token request failed');
        });
    };
    return OAuthHelper;
}());
exports.OAuthHelper = OAuthHelper;
